import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { CORE_CONFIG_TOKEN } from '@ndk/ng-core/component/core.config';
import { Observable } from 'rxjs';

import { ICoreConfigInternal } from '@core/core.config.model';

@Injectable()
export class TermsAndPolicyService {
    private apiUrl: string;

    constructor(
        @Inject(CORE_CONFIG_TOKEN) config: ICoreConfigInternal,
        private http: HttpClient,
    ) {
        this.apiUrl = `${ config.apiEndpoint }api/terms-and-policy`;
    }

    public checkAgreement(): Observable<boolean> {
        return this.http.get<boolean>(`${ this.apiUrl }/check-agreement`);
    }

    public sendAgreement(agreed: boolean): Observable<boolean> {
        return this.http.post<boolean>(`${ this.apiUrl }/send-agreement`, { agreed });
    }
}
